import React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  IPaymentKindPickerProps,
  PaymentKindPicker,
} from '@work4all/components/lib/components/entity-picker/PaymentKindPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface Props extends Omit<IPaymentKindPickerProps<false>, 'multiple'> {
  error?: string;
}

export const PaymentKindPickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const paymentKindWrapperRef = useRef();
    const { error, clearable, ...pickerProps } = props;
    const { value, onChange } = pickerProps;

    return (
      <div ref={reactRefSetter(paymentKindWrapperRef, ref)}>
        <EntityPickerPopover
          anchorEl={paymentKindWrapperRef}
          picker={<PaymentKindPicker {...pickerProps} multiple={false} />}
        >
          <LabeledInput
            onClear={
              clearable
                ? () => {
                    onChange(null);
                  }
                : undefined
            }
            label={t('INPUTS.PAYMENT_KIND')}
            error={error}
            value={value?.note || ''}
          />
        </EntityPickerPopover>
      </div>
    );
  }
);
